import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { getCollections } from '../../../../SingleRequestPage/components/SingleRequestDrawer/helpers/getCollections'
import { CreateServiceRequestFrom } from '../types/NewDrawers.types'

export const defaultValues: CreateServiceRequestFrom = {
  additionalInfo: '',
  address: '',
  addressType: '',
  apartment: '',
  building: '',
  created: '',
  district: '',
  equipmentId: 'Не заполнен',
  house: '',
  locality: '',
  name: '',
  patronymic: '',
  phoneNumber: '',
  preferentialCategories: [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
  ],
  senderId: '',
  surname: '',
  territory: '',
  isUrgent: false,
  orderId: null,
  isRepeatedAppeal: false,
}

export const createServiceRequestFormSchema = z
  .object({
    phoneNumber: z
      .string()
      .transform((val) => val.replace(/\D/g, ''))
      .refine((val) => val.length === 11, {
        path: ['root'], // Указываем путь для ошибки
      }),
    address: z
      .string()
      .min(1)
      .refine((val) => !!val.trim()),
    equipmentId: z.string().optional(),
    preferentialCategories: z.array(z.boolean()).optional(),
    surname: z
      .string()
      .min(1)
      .refine((val) => !!val.trim()),
    name: z
      .string()
      .min(1)
      .refine((val) => !!val.trim()),
    patronymic: z
      .string()
      .min(1)
      .refine((val) => !!val.trim()),
    territory: z.string().min(1),
    district: z.string().min(1),
    locality: z.string().min(1),
    addressType: z.string().nullable(),
    house: z.string().optional(),
    building: z.string().optional(),
    apartment: z.string().optional(),
    created: z.string().optional(),
    additionalInfo: z.string().optional(),
    senderId: z.string().min(1),
    isUrgent: z.boolean().optional(),
    orderId: z.number().nullable(),
    isRepeatedAppeal: z.boolean(),
  })
  .refine(
    (data) => {
      const { districtOptions } = getCollections(
        data.territory,
        data.district,
        data.locality,
        -1,
      )
      return districtOptions.includes(data.district)
    },
    {
      message: 'invalid',
      path: ['district'],
    },
  )
  .refine(
    (data) => {
      const { localitiesOptions } = getCollections(
        data.territory,
        data.district,
        data.locality,
        -1,
      )
      return localitiesOptions.includes(data.locality)
    },
    {
      message: 'invalid',
      path: ['locality'],
    },
  )

export const resolver = zodResolver(createServiceRequestFormSchema)
